import { endpoints } from './endpoints';
import { getAuthToken, request } from './http';

export const uploads = {
    uploadCer(file: File): Promise<unknown> {
        const formData = new FormData();
        formData.append('upload', file);
        return request<unknown>(endpoints.uploads.cer(getAuthToken()), {
            method: 'POST',
            formData,
            credentials: 'omit',
        });
    },
    uploadKey(file: File, password: string): Promise<unknown> {
        const formData = new FormData();
        formData.append('upload', file);
        formData.append('password', password);
        return request<unknown>(endpoints.uploads.key(getAuthToken()), {
            method: 'POST',
            formData,
            credentials: 'omit',
        });
    },
    uploadLogo(file: File, extension: string): Promise<{ logoUrl: string }> {
        return request<{ logoUrl: string }>(endpoints.uploads.logo(getAuthToken(), extension), {
            method: 'POST',
            rawBody: file,
            credentials: 'omit',
        });
    },
};
